import React from "react";
import Service from "../../../../../../../dto/Service";
import { TransitionProps } from "notistack";
import { Box, Button, Card, CircularProgress, Dialog, Divider, Slide, Stack, Typography } from "@mui/material";
import ServiceInfoState from "../../State/ServiceInfoState";
import InfoDispatch from "./model";
import { LoadingButton } from "@mui/lab";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


class Info extends React.PureComponent<{ service: Service | undefined, onClose: () => void }>{

    private itWasClose = true

    render() {
        let state: ServiceInfoState = (this.props as any).state
        let dispatcher: InfoDispatch = (this.props as any).dispatcher


        if (this.props.service && this.itWasClose) {
            this.itWasClose = false
            dispatcher.fetch(this.props.service.id)
        }


        let html: JSX.Element = <div></div>

        if (this.props.service) {
            if (state.loading) {
                html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 1, mb: 1 }} display="flex"
                    justifyContent="center"
                    alignItems="center">
                    <CircularProgress />
                    <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }}>
                        در حال دریافت اطلاعات
                    </Typography>
                </Box>
            } else if (state.error) {
                html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 1, mb: 1 }} display="flex"
                    justifyContent="center"
                    alignItems="center">
                    <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                        اطلاعات دریافت نشد
                    </Typography>
                    <Button variant="contained" color='error' size='small' onClick={() => {
                        dispatcher.fetch(this.props.service!.id)
                    }}>تلاش مجدد</Button>
                </Box>
            } else {
                
                html = <Box sx={{ flexDirection: 'column', display: 'flex', m: 1 }}>
                    {state.data.map((value, index, arr) => {
                        return (
                            <Card key={value.id} variant="outlined" sx={{ flexGrow: 1, borderRadius: '16px', borderColor: 'transparent', bgcolor: `${index % 2 === 0 ? '#f5f5f5' : '#ffffff'}`, m: 0.5, p: 0.5 }}  >


                                <Stack direction="column"
                                    alignItems="center" sx={{ flexGrow: 1 }}>

                                    <Typography variant="subtitle1" sx={{ mr: 0.5, ml: 0.5 }}>
                                        {value.description}
                                    </Typography>

                                    <Box sx={{ flexGrow: 1 }} />
                                    <Box sx={{ flexDirection: 'row', mr: 1, ml: 1 }} display="flex">
                                        <Typography variant="subtitle1">
                                            {value.price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                        </Typography>
                                        <Typography variant="caption" color='GrayText'>
                                            تومان
                                        </Typography>
                                    </Box>
                                    <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />

                                    <LoadingButton loading={state.ordering} variant="contained" size="small" color="info" sx={{ borderRadius: '16px' , width : "100%"}} onClick={() => {
                                        if (window.confirm('آیا از خرید خود اطمینان دارید ؟') === true){
                                            dispatcher.order(value.id)
                                        }
                                          
                                    }}>
                                        خرید
                                    </LoadingButton>
                                </Stack>
                            </Card>
                        )
                    })}
                </Box>
            }
        }


        return (
            <Dialog
                open={this.props.service !== undefined}
                dir="rtl"
                scroll='paper'
                TransitionComponent={Transition} >

                <Box sx={{ width: '100%', minHeight: '200px', flexDirection: 'column' }} display='flex'>
                    <Box sx={{ flexDirection: 'row', p: 1 }} display='flex'>
                        <Box
                            component="img"
                            sx={{
                                height: '100px',
                                width: '100px'
                            }}
                            alt='services'
                            src={this.props.service?.icon}
                            crossOrigin='anonymous'
                        />
                        <Box sx={{ flexDirection: 'column', mr: 2 }} display='flex' justifyContent='center'>
                            <Typography fontWeight='fontWeightBold' variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1, mb: 0 }} color='primary'>
                                {this.props.service?.title}
                            </Typography>

                        </Box>



                    </Box>

                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ mt: 1 }} />
                    {html}
                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ mt: 1 }} />

                    <Button onClick={() => {
                        this.itWasClose = true

                        this.props.onClose()
                    }}>بستن</Button>
                </Box>

            </Dialog>
        )
    }
}

export default Info